module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-46.86cfffdd.png";